"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxConfig = void 0;
const decimal_js_1 = require("decimal.js");
const BaseModels_1 = require("./BaseModels");
const tax_models_1 = require("./tax-models");
/**
 * TaxConfig entity class
 * Equivalent to Java's TaxRate class
 */
class TaxConfig extends BaseModels_1.CompanyBaseModel {
    constructor(taxRate, dollarBased) {
        super();
        Object.assign(this, taxRate);
        this.rateAmount = new decimal_js_1.Decimal(taxRate.rateAmount);
        if (taxRate.rateType === tax_models_1.RateType.FLAT && !dollarBased) {
            this.rateAmount = this.rateAmount.dividedBy(100);
        }
    }
    /**
     * Get effective display name
     * Equivalent to @JsonIgnore getEffectiveDisplayName() in Java
     * Uses StringUtils.isNotEmpty(displayName) logic
     */
    getEffectiveDisplayName() {
        // Equivalent to StringUtils.isNotEmpty(displayName) ? displayName : name
        return (this.displayName && this.displayName.trim().length > 0) ? this.displayName : this.name;
    }
    prepare(companyId) {
        super.prepare(companyId);
    }
}
exports.TaxConfig = TaxConfig;
//# sourceMappingURL=TaxConfig.js.map